module.exports = __webpack_public_path__ + "static/media/education-object-1-2-1.2f8aaecb.svg";